// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:09:01+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            dccd97b615daaaf18fa8fe92a0fcfb36
//    Signature:      eyJpdiI6IlBUa1F2K1A0VFJMMFBLWTBPN1lrUnc9PSIsInZhbHVlIjoiMFNENUk2VjVoOVdNeng3aXBhdVwvdjZrNitRWGFKSjZBeFMyQ29pVlpMZGV6NkpSTjdwbUN2bVRzalQ2VVo2b20zQmNDRGtjUW8zWWFEcVpUVjNyRU00TGduYjljT2tHa2IwM2QyWlpSVHFcLzJsRjhzT0pVU2l4NFVDdWxqeXo5dWRsODl4c1NaKzViaFVOcHRnUUx6VElpbkxrN1wvcDZkblpFVUdVTXhOekswNDBhdzZzdVpUZ2gyMHZRRU16T3ZVR0RcL3JuTXgwSXNxSXN0RklsRHJ0UGdNckdYTWtxb2VqaHhKU0tid2tqK1Q0bVprVkxnRk42ZE9KejVWY01FRWdYXC9MYlNQdmRlMTQ2dmR0NnpYbmlWTHBOSG9qWWtNQ2FVVHRjQldOQmpcL3FcL0pzcWljbko4S1AzOUNNYjJKYXBFOGFzTGdNb3FBK0w5cVBLSWx4OXBsM1FtRjY5MzZZdUs0UEFpSkFWN1JkV2g3c3RpQ2pYUnZUejZzRDJkOHU0RWlwSlB6aXRkYlFjT0Z2ODh0YXJ6UkxEaGNTdnNmVTB2RVQ2SXk2TW5rQjQ9IiwibWFjIjoiMTE5ZjA0MzYyN2RkOTNlYjVhZDRjYjNkZjUxYWVmMTUwMWI0NTgyMzMyMTJkYWIyMWI0MTA1MzBlZTBhYTNkMCJ9
$(document).ready(function () {
    let x=8;
    let to_show = 8;
    let size_li = $(".accordion-item.active").length;
    if (size_li > to_show) {
      $('.load-more-module').removeClass('hide')
    }
    let percentage = (x / size_li)*100;
    $('.fill').css('width', percentage+'%');
    $('.accordion-item.active:lt('+x+')').removeClass('hide');
    $('.accordion-item.active:lt('+x+')').addClass('active');
    $('#viewed-count').html(x)
    $('.loadMore').click(function () {
        x= (x+to_show <= size_li) ? x+to_show : size_li;
        $('#viewed-count').html(x)
        percentage = (x / size_li)*100;
        $('.fill').css('width', percentage+'%');
        $('.accordion-item.active:lt('+x+')').removeClass('hide');
        $('.accordion-item.active:lt('+x+')').addClass('active');
        if(x == size_li){
            $('.fill').css('width', '100%');
            $('.loadMore').hide();
        }
    });
  });
